<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card header="Lista Global de Requerimientos">
          <div class="table-responsive rqTable">
            <div class="form-group form-inline pull-left">
              <select v-model="numPages" class="form-control">
                <option v-for="(num,k) in [10, 30, 50, 100]" :key="k" :value="num">{{ num }}</option>
              </select>&nbsp;
              <input v-model="search" type="search" class="form-control" placeholder="Buscar" />
            </div>
            <div class="form-group form-inline pull-right">
              <date-picker
                v-model="date.start"
                lang="es"
                type="date"
                placeholder="Desde"
                required
                format="DD/MM/YYYY"
              ></date-picker>&nbsp;
              <date-picker
                v-model="date.end"
                lang="es"
                type="date"
                placeholder="Hasta"
                required
                format="DD/MM/YYYY"
              ></date-picker>&nbsp;
              <button class="btn btn-primary" @click="getExpirations">Buscar</button>
            </div>
            <table class="table table-bordered table-hover table-striped">
              <thead>
                <tr>
                  <th>#RQ</th>
                  <th>BL/Booking</th>
                  <th>Dirección/Zona</th>
                  <th>Fecha</th>
                  <th>Terminal de entrega</th>
                  <th>Fecha Sobre estadía</th>
                  <th>Contenedor</th>
                  <th>Cliente</th>
                  <th>Estado</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(rq,k) in paginated('filteredRqs')"
                  :key="k"
                  @contextmenu.prevent="selectRq(rq)"
                >
                  <td>{{rq.id}}</td>
                  <td>{{rq.service.doc_number}}</td>
                  <td>{{rq.address? `${rq.address.alias} - ${rq.address.place.name}` : ''}}</td>
                  <td>{{rq.date | formatDateTime}}</td>
                  <td>{{rq.deposit ? rq.deposit.name : ''}}</td>
                  <td>{{rq.container_expiration | formatDate}}</td>
                  <td>{{rq.container_number}}</td>
                  <td>{{rq.service.company ? rq.service.company.name : ''}}</td>
                  <td>{{rq.status.name}}</td>
                </tr>
              </tbody>
            </table>
            <paginate name="filteredRqs" :list="filteredRqs" class="paginate-list" :per="numPages"></paginate>
            <paginate-links
              for="filteredRqs"
              :limit="5"
              :show-step-links="true"
              :step-links="{
                next: '>>',
                prev: '<<'
              }"
              :classes="{
                'ul': 'pagination',
                'li': 'page-item',
                'a': 'page-link',
              }"
            ></paginate-links>
            <context-menu id="context-menu" ref="ctxMenu">
              <li @click="Detail()" class="ctx-item">Ver detalle</li>
            </context-menu>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import api from "@/helpers/api";
import constants from "@/constants";
import moment from "moment";

export default {
  data() {
    return {
      rqs: [],
      paginate: ["filteredRqs"],
      search: "",
      numPages: 50,
      date: {
        start: moment()
          .add(-7, "days")
          .format("YYYY-MM-DD 00:00:00"),
        end: moment()
          .add(7, "days")
          .format("YYYY-MM-DD 23:59:59")
      }
    };
  },
  computed: {
    filteredRqs() {
      const searchWord = this.search.toLowerCase();
      return this.rqs.filter(rq => {
        let condition = true;
        if (this.search) {
          condition =
            condition &&
            (rq.service.company.name.toLowerCase().includes(searchWord) ||
              rq.service.doc_number.toLowerCase().includes(searchWord) ||
              rq.deposit.name.toLowerCase().includes(searchWord) ||
              searchWord === rq.id.toString());
        }

        return condition;
      });
    }
  },
  mounted() {
    this.getExpirations();
  },
  methods: {
    getExpirations() {
      let data = {
        start_date: moment(this.date.start).format("YYYY-MM-DD 00:00:00"),
        end_date: moment(this.date.end).format("YYYY-MM-DD 23:59:59")
      };

      api.post(`/expiration_rqs`, data).then(response => {
        this.rqs = response.requeriments;
      });
    },
    selectRq(rq) {
      this.rq = rq;
      this.$refs.ctxMenu.open();
    },
    Detail() {
      this.$router.push(`/requeriments/detail/${this.rq.id}`);
    }
  },
  sockets: {
    connect: function() {
      console.log("socket connected");
    },
    updateRequeriment: function(rq) {
      let index = this.rqs.findIndex(r => r.id === rq.id);
      if (index >= 0) {
        this.rqs.splice(index, 1, rq);
      }
    }
  }
};
</script>
